import { FontAwesome, Ionicons, Foundation, FontAwesome5, MaterialCommunityIcons, Feather } from '@expo/vector-icons';
import React from 'react';

// import Colors from '../constants/Colors';

export default function TabBarIcon(props) {
  const size = props.size ?? 42;
  if(props.type === 'Ionicons'){
    return (
      <Ionicons
        name={props.name}
        size={size}
        color={props.color}
        style={props.style}
      />
    );
  }
  if(props.type === 'FontAwesome'){
    return (
      <FontAwesome
        name={props.name}
        size={size}
        color={props.color}
        style={props.style}
      />
    );
  }
  if (props.type === 'Foundation') {
    return (
      <Foundation
        name={props.name}
        size={size}
        color={props.color}
        style={props.style}
      />
    );
  }
  if (props.type === 'FontAwesome5') {
    return (
      <FontAwesome5
        name={props.name}
        size={size}
        color={props.color}
        style={props.style}
      />
    );
  }
  if (props.type === 'MaterialCommunityIcons') {
    return (
      <MaterialCommunityIcons
        name={props.name}
        size={size}
        color={props.color}
        style={props.style}
      />
    );
  }
  if (props.type === 'Feather') {
    return (
      <Feather
        name={props.name}
        size={size}
        color={props.color}
        style={props.style}
      />
    );
  }
}
